module.exports = __webpack_public_path__ + "img/wiener-bezirkszeitung.3a79e6f9.svg";